<div class="w-[900px] max-w-[90%] mx-auto border-t border-[#acacac] pt-4 pb-4 text-marty-darkFont">
  <p>{{ disclaimerText }}</p>
</div>
